// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Production24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Production24: FC<Production24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M15.5 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-2 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
            <path
                d="M9.67 22a.505.505 0 0 1-.504-.438l-.317-2.512a.5.5 0 0 0-.255-.374l-.391-.218-.008-.005-.345-.2a.515.515 0 0 0-.456-.03l-2.357.98a.512.512 0 0 1-.637-.211l-2.332-3.986a.495.495 0 0 1 .132-.647l2.047-1.534a.498.498 0 0 0 .2-.398v-.854a.498.498 0 0 0-.2-.398L2.2 9.64a.495.495 0 0 1-.132-.647L4.4 5.008a.512.512 0 0 1 .637-.211l2.367.984c.143.06.305.052.44-.02.136-.073.249-.135.385-.214l.167-.097.209-.124a.501.501 0 0 0 .243-.368l.318-2.52A.505.505 0 0 1 9.67 2h4.66c.256 0 .473.188.504.438l.318 2.513c.02.157.113.295.251.374.104.06.225.131.324.192.115.071.291.169.43.244.135.073.295.08.436.021l2.37-.985a.512.512 0 0 1 .637.211l2.332 3.986a.495.495 0 0 1-.132.647l-2.057 1.542a.495.495 0 0 0-.2.377c-.015.411-.015.592-.015.684v.183c0 .156.074.303.2.398l2.046 1.534c.204.152.26.43.133.647l-2.331 3.985a.512.512 0 0 1-.64.21l-2.335-.98a.515.515 0 0 0-.45.026l-.424.236-.01.005-.32.187a.5.5 0 0 0-.245.369l-.318 2.518a.505.505 0 0 1-.504.438H9.67Zm1.163-3.201L10.985 20h2.03l.153-1.207a2.5 2.5 0 0 1 1.223-1.846l.32-.187.045-.026.422-.235a2.516 2.516 0 0 1 2.196-.122l1.135.476.994-1.698-.974-.73a2.498 2.498 0 0 1-1.001-1.998v-.183c0-.115 0-.321.017-.76.03-.764.405-1.457.998-1.902l.985-.737-.996-1.703-1.17.487a2.507 2.507 0 0 1-2.158-.11 12.222 12.222 0 0 1-.526-.299 12.11 12.11 0 0 0-.274-.162 2.507 2.507 0 0 1-1.237-1.856L13.015 4h-2.03l-.153 1.209a2.501 2.501 0 0 1-1.207 1.837l-.2.119-.017.01-.159.093-.02.011a14.97 14.97 0 0 1-.44.244 2.515 2.515 0 0 1-2.152.105l-1.169-.486-.996 1.703.974.73c.624.468 1 1.205 1 1.998v.854c0 .793-.376 1.53-1 1.998l-.974.73.996 1.703 1.158-.482a2.515 2.515 0 0 1 2.228.147l.334.194.38.212a2.5 2.5 0 0 1 1.265 1.87Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Production24;
